module.exports = __webpack_public_path__ + "img/hetong.777cefb7.png";